import styled from 'styled-components';
import { typography } from '../../theme';

export const TextInfoBox = styled.div`
  ${typography.paragraphMediumStyle}
  padding: 16px;
`;
